import userPendWarning from './user/pendWarning'
import userWarningList from './user/warningList'
import userNoticeRule from './user/noticeRule'
import userNoticeList from './user/noticeList'
import userProcessWorkList from './user/processWorkList'
import userCloseWorkList from './user/closeWorkList'
import userComprehensiveInspection from './user/comprehensiveInspection'
import userAwrUnscramble from './user/awrUnscramble'

import adminPendWarning from './admin/pendWarning'
import adminSiteManaging from './admin/siteManaging'
import adminPersonManaging from './admin/personManaging'
import adminServerAuthorization from './admin/serverAuthorization'
import adminProcessWorkList from './admin/processWorkList'
import adminDealingWorkList from './admin/dealingWorkList'
import adminCloseWorkList from './admin/closeWorkList'


const install = (Vue) => {
    Vue.prototype.$mock = {
        userPendWarning,
        userWarningList,
        userNoticeRule,
        userNoticeList,
        userProcessWorkList,
        userCloseWorkList,
        userComprehensiveInspection,
        userAwrUnscramble,
        adminPendWarning,
        adminSiteManaging,
        adminPersonManaging,
        adminServerAuthorization,
        adminProcessWorkList,
        adminDealingWorkList,
        adminCloseWorkList,
    }
}

export default {
    install
}